/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { TransfersControllerCancelTransferMutationResponse, TransfersControllerCancelTransferPathParams } from "../../models/transfersController/TransfersControllerCancelTransfer";

function getTransfersControllerCancelTransferUrl(id: TransfersControllerCancelTransferPathParams["id"]) {
  const res = { method: 'DELETE', url: `/api/v1/transfers/${id}` as const }  
  return res
}

/**
 * @summary Cancel a running transfer
 * {@link /api/v1/transfers/:id}
 */
export async function transfersControllerCancelTransfer(id: TransfersControllerCancelTransferPathParams["id"], config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<TransfersControllerCancelTransferMutationResponse, ResponseErrorConfig<Error>, unknown>({ method : "DELETE", url : getTransfersControllerCancelTransferUrl(id).url.toString(), ... requestConfig })  
  return res.data
}